<template>
  <span
    class="dashboard-nav-meta dashboard-nav-meta-icon"
    :class="{ 'is-placeholder': state !== 'open' }"
    :title="title"
    :aria-hidden="state !== 'open'"
  >
    <ExternalLinkIcon v-if="state === 'open'" :size="size" />
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { s__ } from '@/locale'
import ExternalLinkIcon from './icons/ExternalLinkIcon.vue'

const props = defineProps({
  state: {
    type: String,
    default: 'open',
    validator: value => ['expanded', 'collapsed', 'open'].includes(value),
  },
  size: {
    type: [String, Number],
    default: 16,
  },
})

const title = computed(() => {
  if (props.state !== 'open') return ''
  return s__('Dashboard|Open')
})
</script>

<style scoped>
.dashboard-nav-meta-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  width: 16px;
  height: 16px;
}

.dashboard-nav-meta-icon.is-placeholder {
  opacity: 0;
  pointer-events: none;
}
</style>
